/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { BaseModelFieldValueTranslation } from "Shared/Models";

type ModelFieldValueTranslation = BaseModelFieldValueTranslation;
export default ModelFieldValueTranslation;
